import { PurchasedItem, PurchasedItemType } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";

export { default } from "./RichTextPostView.vue";
export const selector = (item: PurchasedItem): boolean => {
  return item.subject.subjectType === PurchasedItemType.RICH_TEXT_POST;
};
